import PricingOptionsTable from './PricingOptionsTable';

export default PricingOptionsTable;
